import { DesignComponentBase } from "./SDKDesignComponentBase";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DesignComponentVariant extends DesignComponentBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, sources) {
        var _a, _b, _c;
        super(model, sources);
        this.variantPropertyValues = (_a = model.variantPropertyValues) !== null && _a !== void 0 ? _a : null;
        this.parentComponentPersistentId = (_b = model.parentComponentPersistentId) !== null && _b !== void 0 ? _b : null;
        this.isAsset = (_c = model.exportProperties.isAsset) !== null && _c !== void 0 ? _c : null;
    }
}
